import { render, staticRenderFns } from "./DietInfo.vue?vue&type=template&id=6fb023c2&scoped=true&"
import script from "./DietInfo.vue?vue&type=script&lang=js&"
export * from "./DietInfo.vue?vue&type=script&lang=js&"
import style0 from "./DietInfo.vue?vue&type=style&index=0&id=6fb023c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb023c2",
  null
  
)

export default component.exports